export function closestMultipleOf(number: number, step: number) {
  // Check if the number is already a multiple of step
  if (number % step === 0) {
    return number;
  }

  // Calculate the closest multiple by rounding up
  return Math.ceil(number / step) * step;
}
